
/**
 * Module dependencies.
 */

import { color, units } from 'src/styles/utils';
import { navElementAttrs } from './nav-element';
import { navLinkHover } from './nav-theme';
import { theme } from 'styled-tools';
import styled from 'styled-components';

/**
 * Export `NavLink` styled component.
 *
 * `Nav / Button Secondary` in the design system: the links listed inside a
 * mega menu column.
 */

const NavLink = styled.a.attrs(navElementAttrs)`
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  background: none;
  border: 0;
  color: ${color('black')};
  cursor: pointer;
  display: block;
  font-size: 16px;
  line-height: ${units(3)};
  outline: none;
  padding: 0;
  text-align: left;
  text-decoration: none;
  transition: color ${theme('animations.fastTransition')};

  ${navLinkHover}
`;

/**
 * Export `NavLink` styled component.
 */

export default NavLink;
